import * as actions from './communicationTemplate/actions'
import * as mutations from './communicationTemplate/mutations'
import * as getters from './communicationTemplate/getters'

import { dataProps } from './communicationTemplate/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/communicationTemplate.js